import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import { black } from 'Styles/colors';

import PasswordInputOriginal from '../../../PasswordInput/PasswordInput';

export const UpdatePasswordForm = styled.div``;

export const Heading = styled.p`
  ${fontBody(16)};
  color: ${black};
  margin: 0;
  padding: 0;
  margin-bottom: 16px;
  text-align: center;
`;

export const Emphasis = styled.span`
  ${fontTitle(16)};
  color: ${black};
`;

export const PasswordInput = styled(PasswordInputOriginal)`
  margin-bottom: 16px;
`;
